export default "__VITE_ASSET__B2l4mGjT__"